import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import { toLonLat } from 'ol/proj';
import React, { useMemo } from 'react';
import { RiCrosshair2Line } from 'react-icons/ri';
import { useStore, useDispatch, useSelector } from 'react-redux';

import styles from './index.module.scss';

import actions from '@/actions';
import OlMap from '@/helpers/OlMap';
import useHandlerWithMoveCheck from '@/hooks/useHandlerWithMoveCheck';
import { getElevation } from '@/utils/MapUtils';

const cx = classNames.bind(styles);

const ClickPoint = () => {
  const store = useStore();
  const dispatch = useDispatch();
  const mode = useSelector((state) => state.editor.mode);
  const map = OlMap.getMap();
  const { handleWithMoveCheck } = useHandlerWithMoveCheck();

  const pressed = useMemo(() => {
    return mode === 'path/point';
  }, [mode]);

  useUpdateEffect(() => {
    if (!pressed) return;

    map.on('click', handleClick);

    return () => {
      map.un('click', handleClick);
    };
  }, [pressed]);

  const handleClick = (e) => {
    const features = map.getFeaturesAtPixel(e.pixel);

    // 클릭 지점에 Feature 존재 시
    if (features.length > 0) return;

    const [lng, lat] = toLonLat(e.coordinate);
    addWaypoint({ lat, lng });
  };

  // 경로점 추가
  const addWaypoint = async (position) => {
    const elevation = await getElevation(position);
    const { altitude } = store.getState().editor.config;
    const waypoint = { position, elevation, altitude };

    dispatch(actions.mission.appendWaypoint(waypoint));
  };

  const toggle = () => {
    if (pressed) {
      dispatch(actions.editor.changeMode(null));
    } else {
      dispatch(actions.editor.changeMode('path/point'));
    }
  };

  return (
    <div className={cx('container')}>
      <div className={cx(['button', { pressed }])} onClick={handleWithMoveCheck(toggle)}>
        <RiCrosshair2Line size={20} />
        <div className={cx('label')}>Point</div>
      </div>
    </div>
  );
};

export default ClickPoint;
